<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class=WordSection1>

  <p class=MsoNormal style='
text-align:center'><span style='font-size:10.0pt;line-height:107%'>&nbsp;</span></p>

  <p class=MsoNormal style='
text-align:center'><strong><span style='font-size:15.0pt;line-height:107%'>CONDITIONS
GENERALES DE VENTE DES PRESTATIONS </span></strong></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><strong><span
    style='font-size:10.0pt;line-height:107%'>ARTICLE 1&nbsp;: Général – </span></strong></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><span
    style='font-size:10.0pt;line-height:107%'>1.1 Définitions- </span></p>

  <p class=MsoListParagraph style='margin: 0 0 0 25.05pt;text-indent:-18.0pt'><span
    style='font-size:10.0pt;line-height:107%'>1.1.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>
</span></span><span style='font-size:10.0pt;line-height:107%'>Client- par
client sera compris toute personne, physique ou morale, qui reçoit de la part
de l’entreprise prestataire, contre payement, des services. </span></p>

  <p class=MsoListParagraph style='margin: 0 0 0 25.05pt;text-indent:-18.0pt'><span
    style='font-size:10.0pt;line-height:107%'>1.1.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>
</span></span><span style='font-size:10.0pt;line-height:107%'>Prestataire- par
prestataire sera compris la société fournisseuse des services. </span></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><span
    style='font-size:10.0pt;line-height:107%'>1.2 Applicabilité&nbsp;</span><span
    style='font-size:10.0pt;line-height:107%'>-&nbsp; en application de l’article L 441-6
du Code de Commerce et de l’article L-111-2 du Code du Consommation, &nbsp;les
présentes conditions générales de vente s’appliquent à toutes les prestations
effectuées pour le Client par le Prestataire et sont complétées autant que de
besoin par des conditions particulières&nbsp;; elles prévalent sur toute
condition générale d’achat ou tout autre document même plus récent émis par le
Client, sauf dérogation écrite et préalable de la part du Prestataire. Le fait
pour le Prestataire de ne pas invoquer l’une quelconque des clauses des
conditions générales ou particulières ou de ne pas se prévaloir de leur
violation, ne vaut pas renonciation au bénéfice desdites clauses. </span></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><span
    style='font-size:10.0pt;line-height:107%'>1.2 Indépendance&nbsp;- </span><span
    style='font-size:10.0pt;line-height:107%'>&nbsp;le Client et le Prestataire sont
juridiquement indépendants et les présentes conditions générales ne sauraient
s’analyser comme créant une société commune entre eux.</span></p>

  <p class=MsoNormal style='margin-bottom:6.0pt'><strong><span style='font-size:
1.0pt;line-height:107%'>&nbsp;</span></strong></p>

  <p class=MsoNormal style='margin-bottom:6.0pt'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 2&nbsp;: Objet - </span></strong><span
    style='font-size:10.0pt;line-height:107%'>Le Prestataire s’engage à collecter et
traiter, dans les conditions légales et réglementaires, les
coproduits/sous-produits/déchets que le Client lui confie.</span></p>

  <p class=MsoNormal style='margin-bottom:6.0pt'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 3&nbsp;: Acceptation - </span></strong><span
    style='font-size:10.0pt;line-height:107%'>Toute demande de prestation faite par
le Client lui-même ou tout intermédiaire dûment habilité par lui ne lie le
Prestataire que si ce dernier confirme son acceptation.</span></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><strong><span
    style='font-size:10.0pt;line-height:107%'>ARTICLE 4&nbsp;: Qualité et
traçabilité –</span></strong></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><span
    style='font-size:10.0pt;line-height:107%'>4.1 Qualité</span><span
    style='font-size:10.0pt;line-height:107%'> – Le Prestataire et Client
reconnaissent qu’une démarche qualité est nécessaire. A ce titre, le Client
reconnait avoir eu connaissance du (des) cahier(s) des charges relatif(s) aux
coproduits/sous-produits/déchets à collecter et s’engage à le(s) respecter. Le
Prestataire se réserve le droit de ne pas collecter les
coproduits/sous-produits/déchets en cas de non-conformité apparente avec le
cahier des charges correspondant constatée au moment de l’enlèvement. Dans ce
cas, le Client restera redevable des coûts du passage infructueux.</span></p>

  <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><span
    style='font-size:10.0pt;line-height:107%'>4.2 Traçabilité</span><span
    style='font-size:10.0pt;line-height:107%'> – Quand la réglementation prévoit
l’établissement de documents d’accompagnement, de registres ou l’application de
règles de traçabilité, le Client établit les documents /registres ou applique
les règles prescrites pour le coproduit/sous-produit/déchet concerné. Le Client
met en place l’organisation nécessaire pour assurer la validité et la conformité
des documents émis et pour remettre les exemplaires requis au Prestataire (ou
au transporteur affrété par lui) et conserve les exemplaires qui lui incombent
pendent les délais prescrits par la réglementation. </span></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><strong><span
    style='font-size:10.0pt;line-height:107%'>ARTICLE 5&nbsp;: Stockage des coproduits/sous-produits/déchets
collectés</span></strong></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>5.1 Stockage
conforme-</span><span style='font-size:10.0pt;line-height:107%'> les
coproduits/sous-produits/déchets collectés doivent être stockés dans des
conditions conformes aux contraintes règlementaires spécifiques aux
coproduits/sous-produits/déchets collectés et compatibles avec les exigences
techniques des équipements de collecte. Dans les cas de
coproduits/sous-produits/déchets stockés dans des contenants (bacs, bennes,
caisses palettes, etc.) le Client se charge de les maintenir en bon état et
veille à les remplir en conformité avec les bonnes pratiques applicables en la
matière afin, notamment, d’éviter au Prestataire (ou au transporteur affrété
par lui) tout problème de surcharge ou de charge déséquilibrée lorsque le
Prestataire (ou le transporteur affrété par lui) enlève et transporte vers les
installations de traitement les coproduits/sous-produits/déchets avec leurs
contenants. </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>5.2 Location des
contenants-</span><span style='font-size:10.0pt;line-height:107%'>&nbsp; si
le Client le demande, le Prestataire (ou le transporteur affrété par lui) peut
fournir ces contenants moyennant un prix de location précisé aux conditions
particulières. Le Client s’engage alors à être titulaire d’une police
d’assurance souscrite auprès d’une compagnie d’assurances notoirement solvable,
garantissant les contenants contre tous types de risques et pour tous types de
dommages qu’ils pourraient subir ou causer&nbsp;; à tout moment, lors de
l’exécution du présent contrat, le Prestataire aura la possibilité d’exiger du
Client la communication d’une attestation de la police d’assurance souscrite.</span></p>

  <p class=MsoNormal style='margin-bottom:.0001pt'><strong><span
    style='font-size:10.0pt;line-height:107%'>ARTICLE 6&nbsp;: Collecte des
coproduits/sous-produits/déchets</span></strong></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>6.1 Conditions de
chargement des coproduits/sous-produits/déchets collectés</span><span
    style='font-size:10.0pt;line-height:107%'> – Dès lors que le Client confie au
Prestataire la collecte des coproduits/sous-produits/déchets, l’accès au lieu
de stockage des coproduits/sous-produits/déchets sera libre et adapté aux
véhicules du Prestataire (ou au transporteur affrété par lui) aux horaires
précisés, le cas échéant, aux conditions particulières.</span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>6.2 Fréquence de la
collecte</span><span style='font-size:10.0pt;line-height:107%'> </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>a. Collecte
récurrente&nbsp;: les parties définissent la fréquence des tours de collecte
sur la base de l’activité standard du Client, pour chaque type de
coproduits/sous-produits/déchets à collecter. Les parties adapteront, autant
que nécessaire, la fréquence des tours de collecte en fonction des types et
quantités de coproduits/sous-produits/déchets à collecter afin que le
Prestataire soit constamment en mesure de respecter les contraintes
réglementaires en matière de délais de traitement desdits
coproduits/sous-produits/déchets.</span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>b. Collecte
ponctuelle&nbsp;: le Client adresse au Prestataire sa demande de collecte dans
les meilleurs délais et en respectant la limite réglementaire qui lui est
applicable afin que le Prestataire soit constamment en mesure de respecter les
contraintes réglementaires en matière de délais de traitement desdits
coproduits/sous-produits/déchets.</span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 7 – Traitement des
coproduits/sous-produits/déchets collectés – </span></strong><span
    style='font-size:10.0pt;line-height:107%'>Les coproduits/sous-produits/déchets
collectés par le Prestataire sont traités dans des installations dûment agréées
pour leur traitement.</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 8 – Prix </span></strong><span style='font-size:
10.0pt;line-height:107%'>– Les conditions tarifaires et particulières précisent
le prix des prestations pour chaque coproduit/sous-produit/déchet collecté. </span></p>

  <p class=MsoNormal style='text-align:
justify'><strong><span style='font-size:10.0pt;line-height:107%'>ARTICLE 9 –
Paiement </span></strong><span style='font-size:10.0pt;line-height:107%'>– </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>9.1 Exécution
parfaite du contrat et escomptes- </span><span style='font-size:10.0pt;
line-height:107%'>Sauf accord contraire écrit, le paiement &nbsp;est dû au
moment de la collecte. Aucun escompte ne sera accordé. </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>9.2 Renoncement au
droit de rétractation&nbsp;: </span><span style='font-size:10.0pt;
line-height:107%'>En application de l’article L 121-21-8 de la Loi 2014—344 du
17 mars 2014 relative à la consommation, les lois et les directives européennes
concernant la sante publique, les règles sanitaires et le Code rural, en
donnant son accord exprès pour la collecte, le Client renonce expressément à
son droit de rétractation pour les contrats conclus à distance. </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>9.3 Demeure-</span><span
    style='font-size:10.0pt;line-height:107%'> Toute somme non payée à l’échéance
produit de plein droit, à partir du jour suivant l’échéance, sans formalité, ni
mise en demeure préalable, intérêt à un taux égal à 3 (trois) fois le taux
d’intérêt légal au temps de l’émission de la facture et donne droit au
Prestataire à une indemnisation forfaitaire de frais de recouvrement de 40
(quarante) euros. </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>9.4 Conséquences de
la demeure</span><span style='font-size:10.0pt;line-height:107%'>- Le
Prestataire se réserve le droit de suspendre ses prestations tant que le client
reste lui devoir une somme en principal, frais et intérêt. De plus, le Client
est redevable pour tout retard de paiement, à titre de clause pénale, d’un
montant de 15% des sommes restant dues. Le retard de paiement par le client
d’une seule facture ou échéance entraine, sur simple notification du
Prestataire, l’exigibilité immédiate de toutes les sommes dues par le client, même
si elles ont donné lieu à des lettres de change. </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>9.5 Compensation-</span><span
    style='font-size:10.0pt;line-height:107%'> Aucune compensation autre que les
compensations légales ne peuvent être opérées sans l’accord préalable du
Prestataire. </span></p>

  <p class=MsoNormal style='text-align:
justify'><span style='font-size:10.0pt;line-height:107%'>9.6 Moyens de
payement-</span><span style='font-size:10.0pt;line-height:107%'> Le
Prestataire se réserve le droit d’exiger le paiement comptant&nbsp;: si
l’encours du Client devenait supérieur au plafond accordé par l’assurance-crédit
du Prestataire&nbsp;; En cas de procédure de sauvegarde, de redressement ou
liquidation judiciaire du Client, pour les prestations effectuées
postérieurement au jugement d’ouverture de la procédure.</span></p>

  <p class=MsoNormal style='text-align:
justify'><strong><span style='font-size:10.0pt;line-height:107%'>&nbsp;</span></strong></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 10 – Pénalités</span></strong><span
    style='font-size:10.0pt;line-height:107%'> – Le Prestataire peut appliquer au
Client des pénalités notamment, mais non exclusivement, en cas&nbsp;de présence
d’eau de rajout, d’autres substances, de corps étrangers dans les
coproduits/sous-produits/déchets collectés, ou de temps d’attente avant ou
pendant le chargement supérieur aux temps précisés le cas échéant dans les
conditions particulières.</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 11 – Résiliation</span></strong><span
    style='font-size:10.0pt;line-height:107%'> – Tout contrat passé en application
des présentes conditions générales peut être résilié de plein droit, après une
mise en demeure adressée par lettre recommandées avec accusé de réception
restée infructueuse, sans préavis et sans préjudice des dommages et intérêts
qui pourraient être demandés par une Partie en cas de manquement substantiel de
l’autre Partie à tout ou partie de ses obligations et , pour ce qui concerne le
Client, notamment en cas de non-respect du cahier des charges relatif à la
qualité des coproduits/sous-produits/déchets visé à l’article 4 ci-dessus.</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 12 – Cas de force majeure</span></strong><span
    style='font-size:10.0pt;line-height:107%'> – Si, par suite d’un cas de force
majeure, le Prestataire est obligé d’interrompre ses prestations, l’exécution
du contrat serait suspendue pendant le temps où il serait dans l’impossibilité
d’assurer ses obligations, sa responsabilité ne pouvant être mise en jeu à quel
titre que ce soit. Pour l’application de la présente clause, les parties
conviennent que notamment être considérées comme cas de force majeure, la
guerre, la révolution, les catastrophes naturelles ayant pour conséquence
d’interrompre la circulation routière, ainsi que les barrières de dégel et de
grève, ou la réquisition par la puissance publique des moyens de collecte du
Prestataire.</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 13 – Nullité</span></strong><span
    style='font-size:10.0pt;line-height:107%'> – En cas de nullité d’une des clauses
des conditions générales ou particulières, le Client et Prestataire
remplaceront, d’un commun accord, la clause d’origine.</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 14 – Résolution des différends et compétence
judiciaire</span></strong><span style='font-size:10.0pt;line-height:107%'> – Les
présentes conditions générales sont soumises à la loi française. Tous les
litiges ou toutes les contestations survenues à l’occasion des conventions
passées en leur application, ainsi que lors de la rupture des relations
commerciales entre le Client et le Prestataire seront de la compétence
exclusive du Tribunal de Commerce du siège social de la société prestataire des
services, quelles que soient les conditions particulières de la prestation, le
lieu de conclusion ou d’exécution de la prestation, la nationalité des parties
et, ce, même en cas de pluralité de défendeurs, de demandes incidentes ou
d’appels en garantie. </span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:
10.0pt;line-height:107%'>ARTICLE 15 – Election de domicile</span></strong><span
    style='font-size:10.0pt;line-height:107%'> – Le Client et le Prestataire élisent
domicile en leur siège social respectif.</span></p>

  <p class=MsoNormal style='text-align:right'><span lang=FR-CH
                                                    style='font-family:"Times New Roman", Arial, sans-serif'>Dernière mise à jour&nbsp;: 31 janvier
2017</span></p>

</div>
